import DownloadFile from "./DownloadFile";

export default DownloadFile;